export const grid = {
    breakpoints: {
        xxs: 320,
        xs: 600,
        s: 1024,
        m: 1248,
        l: 1920,
    },
    columns: {
        xxs: '4',
        xs: '8',
        s: '12',
        m: '12',
        l: '12',
    },
    gutters: {
        xxs: '16px',
        xs: '16px',
        s: '24px',
        m: '24px',
        l: '24px',
    },
    margins: {
        xxs: '24px',
        xs: '24px',
        s: '24px',
        m: '24px',
        l: '24px',
    },
    tokens: {
        mobile: 'grid.mobile',
        tablet: 'grid.tablet',
        desktop: 'grid.desktop',
    },
};
